import { isModuleVisibleToUser } from 'components/Sidebar/utils/SidebarRouteLinkHelper';
import { memo } from 'react';
import { useSelectUser } from 'redux/User/selectors';
import { WellFullDetailsDTO } from 'types/well';
import { InnerWellboreWithWellInfo } from 'types/wellbore';

import styles from '../../Sidebar.module.scss';
import { SidebarRoute } from '../../utils/RouteLinks';
import SubRouteLink from '../SubRouteLink';

type SidebarRouteProps = {
  name: string;
  routes: SidebarRoute[];
  well?: WellFullDetailsDTO;
  wellbore?: InnerWellboreWithWellInfo;
};

const SidebarRouteLink = ({ well, wellbore, routes }: SidebarRouteProps): JSX.Element => {
  const user = useSelectUser();

  return isModuleVisibleToUser(user, routes) ? (
    <div className={styles.routesLink}>
      {routes
        .filter(route => route.isHidden !== true)
        .map(route => (
          <SubRouteLink
            key={route.name}
            well={well}
            wellbore={wellbore}
            user={user}
            route={route}
          />
        ))}
    </div>
  ) : (
    <></>
  );
};

export default memo(SidebarRouteLink);
